var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("form", { staticClass: "mt-4" }, [
      _c("img", {
        staticClass: "mb-4",
        attrs: {
          src: require("../assets/bootstrap-logo.svg"),
          alt: "",
          width: "72",
          height: "57",
        },
      }),
      _c("h1", { staticClass: "h3 mb-3 fw-normal" }, [
        _vm._v("Please sign in"),
      ]),
      _c("div", { staticClass: "form-floating mb-3" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "email",
            id: "floatingInput",
            placeholder: "name@example.com",
          },
        }),
        _c("label", { attrs: { for: "floatingInput" } }, [
          _vm._v("Email address"),
        ]),
      ]),
      _c("div", { staticClass: "form-floating" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "password",
            id: "floatingPassword",
            placeholder: "Password",
          },
        }),
        _c("label", { attrs: { for: "floatingPassword" } }, [
          _vm._v("Password"),
        ]),
      ]),
      _c("div", { staticClass: "checkbox mb-3" }, [
        _c("label", [
          _c("input", { attrs: { type: "checkbox", value: "remember-me" } }),
          _vm._v(" Remember me "),
        ]),
      ]),
      _c(
        "button",
        {
          staticClass: "w-100 btn btn-lg btn-primary",
          attrs: { type: "submit" },
        },
        [_vm._v("Sign in")]
      ),
      _c("p", { staticClass: "mt-5 mb-3 text-muted" }, [_vm._v("© 2017–2022")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }